<template>
    <q-page padding><q-toolbar class="column">
            <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">Master Tag</q-toolbar-title>
            <q-breadcrumbs class="q-mr-auto q-ma-sm">
                <q-breadcrumbs-el :label="$t('dashboard')" to="/ " />
                <q-breadcrumbs-el :label="$t('manage')" to="/campaigns" />
                <q-breadcrumbs-el label="Master Tag" exact />
            </q-breadcrumbs>
        </q-toolbar>
        <q-separator spaced />

        <q-div>
            <q-tabs v-model="tab" class="text-dark" active-color="primary" indicator-color="primary" align="justify"
                inline-label mobile-arrows>
                <q-tab name="mastertag" label="Master Tag" />
                <q-tab name="mastertag_v2" label="Master Tag V2" />
                <q-tab name="blocked_logs" :label="$t('mastertag_blocked_logs_tab')" />
            </q-tabs>

            <q-tab-panels v-model="tab" animated>
                <q-tab-panel name="mastertag">
                    <q-card flat bordered class="q-mb-md">
                        <q-card-section class="row q-col-gutter-md">
                            <div class="col-4">
                                <q-select v-model="selectedChannel" use-input :options="channelsFiltered" :label="$t('channel')" clearable
                                    option-label="name" emit-value map-options outlined @filter="filterChannels" />
                            </div>
                            <div class="col-4">
                                <q-select v-model="campaignScope" :options="campaignScopeOptions" :label="$t('mastertag_campaign_scope')" emit-value map-options outlined :disable="selectedChannel == null" />
                            </div>

                            

                            <div class="col-4">
                                <q-select v-model="selectedCampaign" use-input :options="campaignsFiltered" :label="$t('campaigns')"
                                    option-label="campaignName" multiple :disable="selectedChannel == null" emit-value
                                    clearable outlined @filter="filterCampaigns" />
                            </div>
                        </q-card-section>
                    </q-card>

                    <q-table flat bordered :grid="false" :data="selectedCampaign ? selectedCampaign : campaigns"
                        row-key="id" :columns="columns" class="row-5 sticky-column-table">
                        <template v-slot:header="props">
                            <q-tr :props="props">
                                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                    {{ col.label }}
                                </q-th>
                                <q-th auto-width />
                            </q-tr>
                        </template>

                        <template v-slot:body="props">
                            <q-tr class="" :props="props">
                                <q-td v-for="col in props.cols" :key="col.name" :props="props">
                                    <p v-if="col.name == 'channel_name'">
                                        {{ selectedChannel?.displayName ?? selectedChannel?.name }}
                                    </p>
                                    <p v-else>
                                        {{ col.value }}
                                    </p>
                                </q-td>
                                <q-td auto-width>
                                    <q-btn size="md" color="primary" round unelevated dense @click="toggleExpand(props)"
                                        :icon="props.rowIndex === expandedAffiliateIndex ? 'remove' : 'add'" />
                                </q-td>
                            </q-tr>
                            <q-tr v-show="props.rowIndex === expandedAffiliateIndex" :props="props">
                                <q-td colspan="100%" class="q-pa-none" style="padding: 0">
                                    <q-table :data="scripts" flat hide-bottom row-key="index" :columns="columnsChild"
                                        :pagination="{ rowsPerPage: 0 }">
                                        <template v-slot:body-cell-script="props">
                                            <q-td :props="props">
                                                <q-input v-model="props.row.script_template" outlined type="textarea" />
                                            </q-td>
                                        </template>
                                        <template v-slot:body-cell-actions="props">
                                            <q-td :props="props">
                                                <div class="row no-wrap items-center justify-end q-gutter-sm">
                                                    <q-btn
                                                        :icon="props.row.sri_enabled ? 'mdi-shield-check' : 'mdi-shield-off-outline'"
                                                        round
                                                        :unelevated="!!props.row.sri_enabled"
                                                        :flat="!props.row.sri_enabled"
                                                        :color="props.row.sri_enabled ? 'info' : 'grey-6'"
                                                        :disable="!props.row.id"
                                                        @click="toggleScriptSri(props, !props.row.sri_enabled)"
                                                    >
                                                        <q-tooltip anchor="top middle" self="center middle"
                                                            content-class="bg-secondary text-white"
                                                            content-style="font-size: 12px">
                                                            {{ $t('mastertag_sri_script_toggle') }}
                                                        </q-tooltip>
                                                    </q-btn>
                                                    <q-btn
                                                        icon="mdi-content-copy"
                                                        round
                                                        color="secondary"
                                                        unelevated
                                                        :disable="!props.row.id || !props.row.script_template"
                                                        @click="copyScriptWithSri(props)"
                                                    >
                                                        <q-tooltip anchor="top middle" self="center middle"
                                                            content-class="bg-secondary text-white"
                                                            content-style="font-size: 12px">
                                                            {{ $t('mastertag_copy_script_sri') }}
                                                        </q-tooltip>
                                                    </q-btn>
                                                    <q-btn icon="save" round color="positive" unelevated
                                                        :disable="!props.row.script_template" @click="saveScript(props)">
                                                        <q-tooltip anchor="top middle" self="center middle"
                                                            content-class="bg-secondary text-white"
                                                            content-style="font-size: 12px">{{ $t('save') }}
                                                            script</q-tooltip>
                                                    </q-btn>

                                                    <q-btn :icon="props.row.active ? 'pause' : 'play_arrow'" round
                                                        unelevated
                                                        :color="props.row.active ? 'warning' : 'primary'"
                                                        :disable="!props.row.id" @click="toggleScriptStatus(props)">
                                                        <q-tooltip anchor="top middle" self="center middle"
                                                            content-class="bg-secondary text-white"
                                                            content-style="font-size: 12px">
                                                            {{ props.row.active ? $t('pause') : $t('activate') }} script
                                                        </q-tooltip>
                                                    </q-btn>

                                                    <q-btn icon="delete" round color="negative" unelevated
                                                        :disable="!props.row.id" @click="excludeScript(props)">
                                                        <q-tooltip anchor="top middle" self="center middle"
                                                            content-class="bg-secondary text-white"
                                                            content-style="font-size: 12px">{{ $t('delete') }}
                                                            script</q-tooltip>
                                                    </q-btn>
                                                </div>
                                            </q-td>
                                        </template>
                                    </q-table>
                                </q-td>
                            </q-tr>
                        </template>
                    </q-table>

                </q-tab-panel>
                <q-tab-panel name="mastertag_v2">
                    <q-card flat bordered class="q-mb-md">
                        <q-card-section class="row q-col-gutter-md">
                            <div class="col-4">
                                <q-select v-model="v2Filters.campaignSelected" use-input input-debounce="200"
                                    @filter="filterSelectCampaigns" :options="v2Filters.campaignsFiltered"
                                    :label="$t('campaign')" option-label="name" option-value="id" outlined clearable />
                            </div>

                            <div class="col-3">
                                <q-input v-model="v2Filters.campaignIdV3" label="ID Campanha V3" outlined type="number"
                                    @blur="onCampaignIdV3Blur" />
                            </div>

                            <div class="col-3">
                                <q-input v-model="v2Filters.campaignIdV2" label="ID Campanha V2" outlined
                                    type="number" />
                            </div>

                            <div class="col-2 flex items-center">
                                <q-btn class="q-px-md" color="positive" :label="$t('search')" unelevated no-caps
                                    @click="searchV2Scripts"
                                    :disable="!v2Filters.campaignIdV3 && !v2Filters.campaignIdV2" />
                            </div>
                        </q-card-section>
                    </q-card>
                    <q-table flat bordered :data="v2Scripts.data" row-key="id" :columns="columnsV2" hide-pagination>
                        <template v-slot:body-cell-script_template="props">
                            <q-td :props="props">
                                <q-input readonly v-model="props.row.script_template" outlined type="textarea" dense
                                    autogrow />
                            </q-td>
                        </template>
                        <template v-slot:body-cell-actions="props">
                            <q-td :props="props" class="text-center">
                                <q-btn icon="mdi-content-copy" unelevated round color="primary"
                                    @click="copyData(props.row.script_template)">
                                    <q-tooltip anchor="top middle" self="center middle"
                                        content-class="bg-secondary text-white" content-style="font-size: 12px">
                                        {{ $t('copy') }}</q-tooltip>
                                </q-btn>
                            </q-td>
                        </template>
                    </q-table>
                </q-tab-panel>

                <q-tab-panel name="blocked_logs">
                    <q-card flat bordered class="q-mb-md">
                        <q-card-section class="row q-col-gutter-md items-end">
                            <div class="col-3">
                                <q-input v-model="blockedLogsFilters.progid" :label="$t('mastertag_blocked_logs_progid')"
                                    outlined type="number" clearable />
                            </div>
                            <div class="col-3">
                                <q-select v-model="blockedLogsFilters.op" :options="blockedLogsOpOptions"
                                    :label="$t('mastertag_blocked_logs_op')" outlined clearable emit-value map-options />
                            </div>
                            <div class="col-2">
                                <q-input v-model="blockedLogsFilters.from" :label="$t('mastertag_blocked_logs_from')"
                                    outlined type="date" clearable />
                            </div>
                            <div class="col-2">
                                <q-input v-model="blockedLogsFilters.to" :label="$t('mastertag_blocked_logs_to')"
                                    outlined type="date" clearable />
                            </div>
                            <div class="col-2 flex items-center">
                                <q-btn class="q-px-md" color="positive" :label="$t('search')" unelevated no-caps
                                    @click="searchBlockedLogs(true)" />
                            </div>
                        </q-card-section>
                    </q-card>

                    <q-table flat bordered :data="blockedLogs" row-key="id" :columns="columnsBlockedLogs"
                        :pagination.sync="blockedLogsPagination"
                        @request="onBlockedLogsRequest">
                        <template v-slot:body-cell-tag_preview="props">
                            <q-td :props="props">
                                <q-input readonly :value="props.row.tag_preview || ''" outlined type="textarea" dense
                                    autogrow />
                            </q-td>
                        </template>
                        <template v-slot:body-cell-created_at="props">
                            <q-td :props="props">
                                {{ formatBlockedLogDate(props.row.created_at) }}
                            </q-td>
                        </template>
                    </q-table>
                </q-tab-panel>
            </q-tab-panels>
        </q-div>
    </q-page>
</template>

<script>
import AdvertiserService from '@/services/AdvertiserService.js';
import AffiliateService from '@/services/AffiliateService.js';
import MastertagService, { SEGMENTATION_BET } from '@/services/MastertagService.js';

export default {
    name: 'MasterTag',
    components: {},
    mixins: [AdvertiserService, AffiliateService, MastertagService],
    data() {
        return {
            tab: 'mastertag',
            campaigns: [],
            campaignsFiltered: [],
            channels: [],
            channelsFiltered: [],
            campaignSites: [],
            campaignSegmentationById: {},
            betCampaignIds: null,
            scripts: [],
            v2Scripts: [],
            expandedAffiliateIndex: -1,
            selectedChannel: null,
            selectedCampaign: null,
            campaignScope: 'related',
            campaignScopeOptions: [
                { label: this.$t('mastertag_campaigns_related'), value: 'related' },
                { label: this.$t('mastertag_campaigns_all'), value: 'all' }
            ],
            v2Filters: {
                campaignSelected: null,
                campaignsList: [],
                campaignsFiltered: [],
                campaignIdV3: null,
                campaignIdV2: null
            },
            blockedLogs: [],
            blockedLogsFilters: {
                progid: null,
                op: null,
                from: null,
                to: null
            },
            blockedLogsOpOptions: [
                { label: 'INSERT', value: 'INSERT' },
                { label: 'UPDATE', value: 'UPDATE' },
                { label: 'CLEANUP', value: 'CLEANUP' }
            ],
            blockedLogsPagination: {
                page: 1,
                rowsPerPage: 50,
                rowsNumber: 0
            },
            /** Segmentação da linha expandida — roteia MASTERTAGGO (BET) vs MASTERTAGGO_V3 (demais) */
            mastertagSegmentationContext: null,
            columnsChild: [
                {
                    name: 'category',
                    label: this.$t('category'),
                    align: 'left',
                    field: 'type',
                    sortable: false
                },
                {
                    name: 'script',
                    align: 'left',
                    label: 'Script',
                    field: 'script',
                    sortable: true
                },
                {
                    name: 'actions',
                    align: 'center',
                    label: this.$t('actions'),
                    sortable: false
                }
            ],
            columns: [
                {
                    name: 'channel_name',
                    align: 'left',
                    label: this.$t('channel_name'),
                    field: 'channel_name',
                    sortable: true
                },
                {
                    name: 'campaign_name',
                    align: 'left',
                    label: this.$t('campaign_name'),
                    field: 'campaignName',
                    sortable: true
                }
            ],
            columnsV2: [
                {
                    name: 'siteid',
                    align: 'left',
                    label: this.$t('channel') + ' ID',
                    field: 'siteid',
                    sortable: true
                },
                {
                    name: 'type',
                    align: 'left',
                    label: this.$t('category'),
                    field: 'type',
                    sortable: true
                },
                {
                    name: 'script_template',
                    align: 'left',
                    label: 'Script',
                    field: 'script_template',
                    sortable: false
                },
                {
                    name: 'actions',
                    align: 'center',
                    label: this.$t('actions'),
                    sortable: false
                }
            ],
            columnsBlockedLogs: [
                {
                    name: 'created_at',
                    align: 'left',
                    label: this.$t('mastertag_blocked_logs_date'),
                    field: 'created_at',
                    sortable: false
                },
                {
                    name: 'op',
                    align: 'left',
                    label: this.$t('mastertag_blocked_logs_op'),
                    field: 'op',
                    sortable: false
                },
                {
                    name: 'progid',
                    align: 'left',
                    label: this.$t('mastertag_blocked_logs_progid'),
                    field: 'progid',
                    sortable: false
                },
                {
                    name: 'type',
                    align: 'left',
                    label: this.$t('category'),
                    field: 'type',
                    sortable: false
                },
                {
                    name: 'zone',
                    align: 'left',
                    label: this.$t('mastertag_blocked_logs_zone'),
                    field: 'zone',
                    sortable: false
                },
                {
                    name: 'reason',
                    align: 'left',
                    label: this.$t('mastertag_blocked_logs_reason'),
                    field: 'reason',
                    sortable: false
                },
                {
                    name: 'tag_preview',
                    align: 'left',
                    label: this.$t('mastertag_blocked_logs_preview'),
                    field: 'tag_preview',
                    sortable: false
                }
            ],
        };
    },

    watch: {
        selectedChannel() {
            if (this.selectedChannel) {
                this.getCampaignsOptions();
            } else {
                this.campaigns = [];
            }
        },
        campaignScope() {
            if (this.selectedChannel) this.getCampaignsOptions();
        },
        'v2Filters.campaignSelected'(val) {
            this.v2Filters.campaignIdV3 =
                val !== null && val !== '' ? Number(val.id) : null;
        },
        tab(val) {
            if (val === 'blocked_logs' && this.blockedLogs.length === 0) {
                this.searchBlockedLogs(true);
            }
        }
    },

    async created() {
        await Promise.all([
            this.getChannelsOptions(),
            this.getCampaigns(),
            this.ensureBetCampaignIds()
        ]);
    },

    methods: {
        onCampaignIdV3Blur() {
            if (this.v2Filters.campaignIdV3) {
                this.v2Filters.campaignSelected = this.v2Filters.campaignsList.find(c => c.id === Number(this.v2Filters.campaignIdV3)) || null;
            } else {
                this.v2Filters.campaignSelected = null;
            }
        },

        async ensureBetCampaignIds() {
            if (this.betCampaignIds) return this.betCampaignIds;

            try {
                const { data } = await this.getCampaignsBySegmentation(SEGMENTATION_BET);
                const ids = Array.isArray(data) ? data : [];
                this.betCampaignIds = new Set(ids.map((id) => Number(id)));
            } catch (error) {
                // Fallback: resolveCampaignSegmentation tenta getCampaignDetails na expansão.
                this.betCampaignIds = new Set();
            }

            return this.betCampaignIds;
        },

        async resolveCampaignSegmentation(campaignId, segmentation) {
            const value = this.normalizeCampaignSegmentation(segmentation);
            if (value) return value;

            const cached = this.campaignSegmentationById[campaignId];
            if (cached) return cached;

            await this.ensureBetCampaignIds();
            if (this.betCampaignIds.has(Number(campaignId))) {
                this.$set(this.campaignSegmentationById, campaignId, SEGMENTATION_BET);
                return SEGMENTATION_BET;
            }

            try {
                const { data } = await this.getCampaignDetails(campaignId);
                const detailsSegmentation = data?.segmentation ?? data?.segmentation_id ?? null;
                const normalized = this.normalizeCampaignSegmentation(detailsSegmentation);
                this.$set(this.campaignSegmentationById, campaignId, normalized);
                return normalized;
            } catch (error) {
                // Sem segmentação conhecida: mastertagRouting cai em MASTERTAGGO_V3 (comportamento padrão).
                return null;
            }
        },

        normalizeCampaignSegmentation(segmentation) {
            if (segmentation && typeof segmentation === 'object') {
                return segmentation.id ?? segmentation.value ?? segmentation.name ?? null;
            }
            return segmentation ?? null;
        },
        async toggleExpand(props) {
            if (this.expandedAffiliateIndex === props.rowIndex) {
                this.expandedAffiliateIndex = -1;
                this.scripts = [];
                this.mastertagSegmentationContext = null;
            } else {
                try {
                    this.onLoading(true);

                    const campaignId = props.row.campaign_id ?? props.row.id;
                    const segmentation = await this.resolveCampaignSegmentation(campaignId, props.row.segmentation ?? null);
                    const { data } = await this.getScripts(campaignId, this.selectedChannel.id, segmentation);

                    const baseScripts = [
                        { type: 'homepage', progid: campaignId, script_template: '', sri_enabled: false },
                        { type: 'category', progid: campaignId, script_template: '', sri_enabled: false },
                        { type: 'product', progid: campaignId, script_template: '', sri_enabled: false },
                        { type: 'basket', progid: campaignId, script_template: '', sri_enabled: false },
                        { type: 'transaction', progid: campaignId, script_template: '', sri_enabled: false }
                    ];

                    const mergedScripts = data
                        ? baseScripts.map((base) => {
                            const fromApi = data.find((api) => api.type === base.type);

                            return fromApi ? { ...base, ...fromApi } : base;
                        })
                        : baseScripts;
                    this.scripts = mergedScripts;

                    this.mastertagSegmentationContext = segmentation;
                    this.expandedAffiliateIndex = props.rowIndex;
                } catch (error) {
                    this.errorNotify(error);
                } finally {
                    this.onLoading(false);
                }
            }
        },
        async getCampaignsOptions() {
            try {
                this.onLoading(true);
                this.selectedCampaign = null;
                const { data } = this.campaignScope === 'all'
                    ? await this.getAllCampaigns()
                    : await this.listCampaignsForSite(this.selectedChannel.id);
                this.campaigns = data.map((item) => {
                    const id = item.campaign_id ?? item.id;
                    return {
                        campaignName: `${item.campaignName ?? item.name} - (id: ${id})`,
                        id,
                        campaign_id: id,
                        progid: id,
                        segmentation: item.segmentation
                    };
                });
                this.campaignsFiltered = [...this.campaigns];
            } catch (error) {
                this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },

        filterCampaigns(val, update) {
            update(() => {
                const needle = val.toLocaleLowerCase();
                if (!needle) this.campaignsFiltered = this.campaigns;
                this.campaignsFiltered = this.campaigns.filter((v) => v.campaignName.toLocaleLowerCase().indexOf(needle) > -1);
            });
        },

        async getChannelsOptions() {
            try {
                this.onLoading(true);
                const { data } = await this.getAllSitesActive();
                this.channels = data.map((item) => ({
                    name: `${item.name} - (id: ${item.id})`,
                    displayName: item.name,
                    id: item.id
                }));
                this.channelsFiltered = [...this.channels];
            } catch (error) {
                this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },

        filterChannels(val, update) {
            update(() => {
                const needle = val.toLocaleLowerCase();
                if (!needle) this.channelsFiltered = this.channels;
                this.channelsFiltered = this.channels.filter((v) => v.name.toLocaleLowerCase().indexOf(needle) > -1);
            });
        },

        async saveScript(props) {
            try {
                this.onLoading(true);
                const segmentation = this.mastertagSegmentationContext ?? null;
                const userId = this.user?.user_id;
                if (!props.row.id) {
                    const { data } = await this.createScript(
                        props.row.progid,
                        props.row.type,
                        this.selectedChannel.id,
                        props.row.script_template,
                        segmentation,
                        userId
                    );
                    this.modifyScriptsArray(data);
                    this.successNotify(this.$t('script_created'));
                } else {
                    const { data } = await this.updateScript(
                        props.row.script_template,
                        props.row.id,
                        segmentation,
                        userId
                    );
                    this.modifyScriptsArray(data);
                    this.successNotify(this.$t('script_modified'));
                }
            } catch (error) {
                this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },

        parsePreviewScript(payload) {
            const body =
                payload && typeof payload === 'object' && payload.data != null && typeof payload.data === 'object'
                    ? payload.data
                    : payload;
            if (!body) {
                return '';
            }
            if (typeof body === 'string') {
                return body;
            }
            return body.script || '';
        },

        async copyScriptWithSri(props) {
            if (!props.row.id || !props.row.script_template) {
                return;
            }
            try {
                this.onLoading(true);
                const segmentation = this.mastertagSegmentationContext ?? null;
                const response = await this.getScriptPreviewWithSri(props.row.id, segmentation);
                const script = this.parsePreviewScript(response.data);
                if (!script) {
                    this.infoNotify(this.$t('mastertag_copy_script_sri_empty'));
                    return;
                }
                this.copyData(script);
            } catch (error) {
                this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },

        async toggleScriptStatus(props) {
            try {
                this.onLoading(true);
                const newStatus = !props.row.active;
                const message = newStatus ? this.$t('script_activated') : this.$t('script_paused');

                const segmentation = this.mastertagSegmentationContext ?? null;
                const { data, status } = await this.toggleScriptActive(props.row.id, newStatus, segmentation);

                if (status === 200 || status === 204) {
                    this.modifyScriptsArray(data);
                    this.successNotify(message);
                }

            } catch (error) {
                this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },

        async toggleScriptSri(props, enabled) {
            if (!props.row.id) {
                return;
            }
            try {
                this.onLoading(true);
                const segmentation = this.mastertagSegmentationContext ?? null;
                const { data, status } = await this.updateScriptSriEnabled(props.row.id, enabled, segmentation);
                if (status === 200 || status === 204) {
                    this.modifyScriptsArray(data);
                    this.successNotify(this.$t('mastertag_sri_script_saved'));
                }
            } catch (error) {
                this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },

        modifyScriptsArray(newScript) {
            const exists = this.scripts.some((s) => s.type === newScript.type);

            this.scripts = exists
                ? this.scripts.map((s) => (s.type === newScript.type ? { ...newScript } : s))
                : [...this.scripts, newScript];
        },

        async excludeScript(props) {
            try {
                this.onLoading(true);
                const segmentation = this.mastertagSegmentationContext ?? null;
                const { status } = await this.deleteScript(props.row.id, segmentation);
                if (status == 200) {
                    this.modifyScriptsArray({ type: props.row.type, progid: props.row.progid, script_template: '', sri_enabled: false });
                }

                this.successNotify(this.$t('script_deleted'));
            } catch (error) {
                this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },
        async searchV2Scripts() {
            if (this.v2Filters.campaignIdV3 && !this.v2Filters.campaignSelected) {
                this.errorNotify('ID Campanha V3 não encontrado!');
                return;
            }
            try {
                this.onLoading(true);
                const { data } = await this.searchScriptsV2(this.v2Filters.campaignIdV3, this.v2Filters.campaignIdV2);
                this.v2Scripts = data || [];
                if (this.v2Scripts.length === 0) {
                    this.infoNotify('Nenhum script encontrado');
                }
            } catch (error) {
                this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },
        async getCampaigns() {
            this.onLoading(true);
            try {
                const { data, status } = await this.getAllCampaigns();
                if (status === 200) {
                    this.v2Filters.campaignsList = data;
                    this.v2Filters.campaignsFiltered = data;
                }
            } catch (error) {
                if (error.response && error.response.status === 500)
                    this.errorNotify(this.$t('problem_try_again_later'));
                else this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },
        filterSelectCampaigns(val, update) {
            update(() => {
                const needle = val.toLowerCase();

                this.v2Filters.campaignsFiltered = needle
                    ? this.v2Filters.campaignsList.filter(c =>
                        c.name.toLowerCase().includes(needle)
                    )
                    : this.v2Filters.campaignsList;
            });
        },

        formatBlockedLogDate(value) {
            if (!value) return '';
            return this.$moment(value).format('L LTS');
        },

        onBlockedLogsRequest(props) {
            this.blockedLogsPagination = props.pagination;
            this.searchBlockedLogs(false);
        },

        async searchBlockedLogs(resetPage = false) {
            if (resetPage) {
                this.blockedLogsPagination = {
                    ...this.blockedLogsPagination,
                    page: 1
                };
            }

            const { page, rowsPerPage } = this.blockedLogsPagination;
            const limit = rowsPerPage || 50;
            const offset = (page - 1) * limit;

            try {
                this.onLoading(true);
                const { data } = await this.getBlockedLogsV2({
                    progid: this.blockedLogsFilters.progid || undefined,
                    op: this.blockedLogsFilters.op || undefined,
                    from: this.blockedLogsFilters.from || undefined,
                    to: this.blockedLogsFilters.to || undefined,
                    limit,
                    offset
                });

                this.blockedLogs = data?.data || [];
                const total = data?.meta?.total ?? this.blockedLogs.length;
                this.blockedLogsPagination = {
                    ...this.blockedLogsPagination,
                    rowsNumber: total
                };

                if (this.blockedLogs.length === 0) {
                    this.infoNotify(this.$t('mastertag_blocked_logs_empty'));
                }
            } catch (error) {
                this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },
    },

};
</script>
